import React, { useState, useEffect, useRef } from "react";
import FirstStep from "../form/FirstStep";
import SecondStep from "../form/SecondStep";
import ThirdStep from "../form/ThirdStep";
import FourthStep from "../form/FourthStep";
import FifthStep from "../form/FifthStep";
import SixthStep from "../form/SixthStep";
import SeventhStep from "../form/SeventhStep";
import EighthStep from "../form/EighthStep";
import NinthStep from "../form/NinthStep";
import TenthStep from "../form/TenthStep";
import {
  checkIsValidFormSteps,
  updateErrorsFormSteps,
} from "../../services/manageValidation";
import StepController from "../stepController/stepController";
// import Footer from "../../assets/components/Footer";

// import axios from "axios";

// Get parameters from the URL Search and return them in an object
const getUTMParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
    utm_content: params.get("utm_content") || "",
    cc: params.get("cc") || "",
    rdt_cid: params.get("rdt_cid") || "",
    utm_ad_id: params.get("utm_ad_id") || "",
    utm_id: params.get("utm_id") || "",
    ttclid: params.get("ttclid") || "",
    gclid: params.get("gclid") || "",
    utm_term: params.get("utm_term") || "",
    fbclid: params.get("fbclid") || params.get("FBclid") || "",
    referringURL: document.referrer || "", // Captures referring URL
  };
};

// This makes 1 update when finished or closing - desktop only
// const googleSheetUpdate = async (payload, refreshVal) => {
//   const data = {
//     firstName: payload.answers.first_name1 || payload.answers.firstName,
//     lastName: payload.answers["Last Name"],
//     email: payload.answers.email_address,
//     phoneNumber: payload.answers.phone_number,
//     ip: payload.answers.ip,
//     userAgent: payload.answers.user_agent,
//     receivingSSDIBenefits:
//       payload.answers[
//         "Are you currently receiving Social Security Disability benefits?"
//       ],
//     outOfWork:
//       payload.answers["Do you expect to be out of work for at least a year?"],
//     lastYearWorkedFullTime:
//       payload.answers["When did you stop working full time"],
//     workedFiveYearsSince:
//       payload.answers["Have you worked for 5 out of the last 10 years?"],
//     receivingTreatment:
//       payload.answers[
//         "Are you receiving treatment for your medical condition?"
//       ],
//     ageRange:
//       payload.answers["What is the age of the person seeking benefits?"],
//     zipCode: payload.answers.postal_code,
//     attorneyHelping:
//       payload.answers["Is an attorney helping you with your case or claim?"],
//     trustedForm: payload.trusted_form_certificate_url,
//     utm_source: payload.answers.utm_source,
//     utm_medium: payload.answers.utm_medium,
//     utm_campaign: payload.answers.utm_campaign,
//     utm_content: payload.answers.utm_content,
//     utm_id: payload.answers.utm_id,
//     utm_term: payload.answers.utm_term,
//     fbclid: payload.answers.fbclid,
//     referringURL: payload.answers.referrer,
//     createdAt: payload.created_at,
//     form_url: payload.form_url,
//     unique_id: payload.unique_id,
//     gclid: payload.answers.gclid,
//     ttclid: payload.answers.ttclid,
//     utm_ad_id: payload.answers.utm_ad_id,
//     rdt_cid: payload.answers.rdt_cid,
//     cc: payload.answers.cc,
//     formName: payload.form_name,
//     isMobile: payload.isMobile,
//     refresh: payload.refresh,
//   };
//   const sheetURL = process.env.REACT_APP_SHEETBEST_URL;
//   const blob = new Blob([JSON.stringify(data)], {
//     type: "application/json",
//   });
//   navigator.sendBeacon(sheetURL, blob);
//   // const beaconSuccess = navigator.sendBeacon(sheetURL, blob);
//   // if (!beaconSuccess) {
//   //   // Fallback to fetch
//   //   try {
//   //     await fetch(sheetURL, {
//   //       method: "POST",
//   //       headers: {
//   //         "Content-Type": "application/json",
//   //       },
//   //       body: JSON.stringify(data),
//   //       keepalive: true, // important for background unloads
//   //     });
//   //   } catch (e) {
//   //     console.error("Fallback fetch failed:", e);
//   //   }
//   // }
// };

// This makes continunous updates to the sheet - mobile only
const googleSheetUpdateMobile = async (payload) => {
  const data = {
    firstName: payload.answers.first_name1 || payload.answers.firstName,
    lastName: payload.answers["Last Name"],
    email: payload.answers.email_address,
    phoneNumber: payload.answers.phone_number,
    ip: payload.answers.ip,
    userAgent: payload.answers.user_agent,
    receivingSSDIBenefits:
      payload.answers[
        "Are you currently receiving Social Security Disability benefits?"
      ],
    outOfWork:
      payload.answers["Do you expect to be out of work for at least a year?"],
    lastYearWorkedFullTime:
      payload.answers["When did you stop working full time"],
    workedFiveYearsSince:
      payload.answers["Have you worked for 5 out of the last 10 years?"],
    receivingTreatment:
      payload.answers[
        "Are you receiving treatment for your medical condition?"
      ],
    ageRange:
      payload.answers["What is the age of the person seeking benefits?"],
    zipCode: payload.answers.postal_code,
    attorneyHelping:
      payload.answers["Is an attorney helping you with your case or claim?"],
    trustedForm: payload.trusted_form_certificate_url,
    utm_source: payload.answers.utm_source,
    utm_medium: payload.answers.utm_medium,
    utm_campaign: payload.answers.utm_campaign,
    utm_content: payload.answers.utm_content,
    utm_id: payload.answers.utm_id,
    utm_term: payload.answers.utm_term,
    fbclid: payload.answers.fbclid,
    referringURL: payload.answers.referrer,
    createdAt: payload.created_at,
    form_url: payload.form_url,
    unique_id: payload.unique_id,
    gclid: payload.answers.gclid,
    ttclid: payload.answers.ttclid,
    utm_ad_id: payload.answers.utm_ad_id,
    rdt_cid: payload.answers.rdt_cid,
    cc: payload.answers.cc,
    formName: payload.form_name,
    isMobile: payload.isMobile,
    refresh: payload.refresh || false,
  };
  const baseURL = process.env.REACT_APP_SHEETBEST_URL;
  const uniqueId = payload.unique_id;
  const rowCreated = sessionStorage.getItem("row_created");

  try {
    if (!rowCreated) {
      // Check if row already exists in the sheet
      const checkRes = await fetch(`${baseURL}/unique_id/${uniqueId}`);
      const existingRows = await checkRes.json();

      if (existingRows.length > 0) {
        // Already created, just update
        await fetch(`${baseURL}/unique_id/${uniqueId}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });
        sessionStorage.setItem("row_created", "true");
      } else {
        // ➕ Create new row
        await fetch(baseURL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });
        sessionStorage.setItem("row_created", "true");
      }
    } else {
      // Row was already created — just update
      await fetch(`${baseURL}/unique_id/${uniqueId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
    }
  } catch (error) {
    console.error("Error updating/creating row:", error);
  }
  // try {
  //   let hasPosted = false;
  //   if (hasPosted === false) {
  //     // First time: create new row (POST)
  //     const sheetURL = process.env.REACT_APP_SHEETBEST_URL;
  //     await fetch(sheetURL, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(data),
  //     });
  //     hasPosted = true;
  //   } else {
  //     // After first time: update existing row (PUT/PATCH)
  //     // const sheetURL = process.env.REACT_APP_SHEETBEST_URL;
  //     const sheetURL = `${process.env.REACT_APP_SHEETBEST_URL}/unique_id/${payload.unique_id}`;
  //     await fetch(sheetURL, {
  //       method: "PUT",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(data),
  //     });
  //   }
  // } catch (e) {
  //   console.error("Update failed", e);
  // }
};

// // Send whatever data was collected before page closes
// const useBeforeUnload = (payload, formData) => {
//   // const devURL = process.env.REACT_APP_CLOUD_WEBHOOK;
//   // const zapierURL = process.env.REACT_APP_ZAPIER_URL;
//   useEffect(() => {
//     let refreshVal = false;
//     const handleBeforeUnload = () => {
//       // This returns true meaning they refreshed
//       if (formData.receivingSSDIBenefits === "") {
//         return;
//       }
//       googleSheetUpdate(payload, refreshVal);
//       sessionStorage.removeItem("selectedOption1");
//       sessionStorage.removeItem("selectedOption2");
//       sessionStorage.removeItem("selectedOption3");
//       sessionStorage.removeItem("selectedOption4");
//       sessionStorage.removeItem("selectedOption6");
//       sessionStorage.removeItem("selectedOption7");
//       sessionStorage.removeItem("selectedOption9");
//       // sessionStorage.removeItem("formData");
//       // sessionStorage.removeItem("currentStep");
//       // const refresh =
//       //   performance.getEntriesByType("navigation")[0]?.type === "reload";

//       // if (refresh && formData.receivingSSDIBenefits !== "") {
//       //   refreshVal = true
//       //   // User refreshed the page even while working through the form
//       //   // Save formdata in session storage.
//       //   // sessionStorage.setItem("formData", JSON.stringify(formData));
//       //   googleSheetUpdate(payload, refreshVal);
//       //   return;
//       // } else if (!refresh && formData.receivingSSDIBenefits !== "") {
//       //   // User is leaving the page and didn't get past the first answer, update google sheet and clear questions.
//       //   // Also clear formdata in session storage
//       //   googleSheetUpdate(payload);
//       // } else if (!refresh && formData.receivingSSDIBenefits === "") {
//       //   // User is leaving the page after getting past the first answer update google sheet and clear questions.
//       //   // Also clear formdata in session storage
//       //   googleSheetUpdate(payload);
//       // }
//       return;
//     };
//     // Desktop + some mobile support
//     window.addEventListener("beforeunload", handleBeforeUnload);
//     return () => {
//       // Cleanup the event listener to avoid memory leaks
//       window.removeEventListener("beforeunload", handleBeforeUnload);
//     };
//     // devURL, zapierURL
//   }, [payload, formData, formData.receivingSSDIBenefits]);
// };

// Control form state and pass the step to the stepcontroller
const Form = () => {
  const [validationError, setValidationError] = useState([]);
  const [userIPAdress, setUserIPAdress] = useState("");
  const [trustedFormCert, setTrustedFormCert] = useState("");
  const refreshed =
    performance.getEntriesByType("navigation")[0]?.type === "reload";

  // Create date for when form was submitted and user agent
  const newDate = new Date();
  const userAgent = window.navigator.userAgent;
  const formUrl = window.location.href;
  const urlWithoutParameters = formUrl.split("?")[0];
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const uniqueIdRef = useRef(
    sessionStorage.getItem("unique_id") || crypto.randomUUID()
  );

  // Initialize form data state
  const [formData, setFormData] = useState({
    // Form Parameters
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    receivingSSDIBenefits: "",
    outOfWork: "",
    lastYearWorked: "",
    workedFiveYearsSince: "",
    receivingTreatment: "",
    ageRange: "",
    zipCode: "",
    attorneyHelping: "",
    trustedForm: "",
    // UTM Parameters
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_content: "",
    cc: "",
    utm_id: "",
    utm_ad_id: "",
    utm_term: "",
    fbclid: "",
    ttclid: "",
    rdt_cid: "",
    // Other Parameters
    userAgent: userAgent,
    createdAt: newDate,
    form_url: urlWithoutParameters, // Store the URL without parameters
    unique_id: uniqueIdRef.current,
    isMobile: isMobile,
    refresh: refreshed,
  });

  // const [formData, setFormData] = useState(() => {
  //   const savedForm = sessionStorage.getItem("formData");
  //   let parsed = {};

  //   if (savedForm) {
  //     try {
  //       parsed = JSON.parse(savedForm);
  //       // Always ensure required fields like userAgent and createdAt are kept fresh
  //     } catch (e) {
  //       console.error("Error parsing saved form data", e);
  //     }
  //   }
  //   return {
  //     firstName: parsed.firstName || "",
  //     lastName: parsed.lastName || "",
  //     phoneNumber: parsed.phoneNumber || "",
  //     email: parsed.email || "",
  //     receivingSSDIBenefits: parsed.receivingSSDIBenefits || "",
  //     outOfWork: parsed.outOfWork || "",
  //     lastYearWorked: parsed.lastYearWorked || "",
  //     workedFiveYearsSince: parsed.workedFiveYearsSince || "",
  //     receivingTreatment: parsed.receivingTreatment || "",
  //     ageRange: parsed.ageRange || "",
  //     zipCode: parsed.zipCode || "",
  //     attorneyHelping: parsed.attorneyHelping || "",
  //     trustedForm: parsed.trustedForm || "",
  //     utm_source: parsed.utm_source || "",
  //     utm_medium: parsed.utm_medium || "",
  //     utm_campaign: parsed.utm_campaign || "",
  //     utm_content: parsed.utm_content || "",
  //     cc: parsed.cc || "",
  //     utm_id: parsed.utm_id || "",
  //     utm_ad_id: parsed.utm_ad_id || "",
  //     utm_term: parsed.utm_term || "",
  //     fbclid: parsed.fbclid || "",
  //     ttclid: parsed.ttclid || "",
  //     rdt_cid: parsed.rdt_cid || "",
  //     userAgent: userAgent,
  //     createdAt: newDate,
  //     form_url: urlWithoutParameters,
  //     unique_id: parsed.unique_id || crypto.randomUUID(),
  //   };
  // });

  // Payload for Zapier
  let payload = {
    answers: {
      email_address: formData.email,
      ip: userIPAdress,
      first_name1: formData.firstName,
      utm_content: formData.utm_content,
      "First Name": formData.firstName,
      user_agent: userAgent,
      "Is an attorney helping you with your case or claim?":
        formData.attorneyHelping,
      utm_term: formData.utm_term,
      utm_campaign: formData.utm_campaign,
      cc: formData.cc,
      referrer: formData.referringURL,
      utm_medium: formData.utm_medium,
      utm_id: formData.utm_id,
      fbclid: formData.fbclid,
      "What is the age of the person seeking benefits?": formData.ageRange,
      "Last Name": formData.lastName,
      postal_code: formData.zipCode,
      "Are you receiving treatment for your medical condition?":
        formData.receivingTreatment,
      "When did you stop working full time": formData.lastYearWorked,
      "Have you worked for 5 out of the last 10 years?":
        formData.workedFiveYearsSince,
      phone_number: formData.phoneNumber,
      "Do you expect to be out of work for at least a year?":
        formData.outOfWork,
      utm_source: formData.utm_source,
      gclid: formData.gclid,
      ttclid: formData.ttclid,
      utm_ad_id: formData.utm_ad_id,
      "Are you currently receiving Social Security Disability benefits?":
        formData.receivingSSDIBenefits,
    },
    form_name: "Atticus Flow",
    trusted_form_certificate_url: formData.trustedForm,
    form_url: formData.form_url,
    unique_id: formData.unique_id,
    created_at: newDate.toISOString(),
    isMobile: formData.isMobile,
    refresh: formData.refresh,
  };

  const clearStorage = () => {
    // Clear on refresh
    // sessionStorage.removeItem("unique_id");
    sessionStorage.removeItem("selectedOption1");
    sessionStorage.removeItem("selectedOption2");
    sessionStorage.removeItem("selectedOption3");
    sessionStorage.removeItem("selectedOption4");
    sessionStorage.removeItem("selectedOption6");
    sessionStorage.removeItem("selectedOption7");
    sessionStorage.removeItem("selectedOption9");
    sessionStorage.removeItem("formData");
    sessionStorage.removeItem("currentStep");
  };

  // Form change to update state
  const handleFieldChange = (name, value, isRequired) => {
    let valueChange = value;
    setFormData({ ...formData, [name]: valueChange });
    isRequired &&
      setValidationError(
        validationError.filter((errorItem) => errorItem !== name)
      );
  };

  // Step validation
  const manageNextStepValidation = (step) => {
    const isValid = checkIsValidFormSteps({ formData, step });
    // If not valid
    if (!isValid) {
      // Check for proper zipcode
      let zipCodeCheckRegex = /[a-zA-Z]/g;
      if (step === 8 && formData.zipCode === "") {
        // If the zip code input is empty, we need to show an error message
        document.querySelector(".errorTextAnswer").style.display = "block";
        document.querySelector(".errorZipCodeText").style.display = "none";
      } else if (
        step === 8 &&
        zipCodeCheckRegex.test(formData.zipCode) !== ""
      ) {
        // If the zip code is not valid, we need to show an error message
        document.querySelector(".errorZipCodeText").style.display = "block";
        document.querySelector(".errorTextAnswer").style.display = "none";
      }

      // Regex for email and phone number
      let emailCheckRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const oldPhoneNumber = formData.phoneNumber; // The phone validation is done on step 10 but the logic is here
      let phoneCheckRegex = /^\d{3}-\d{3}-\d{4}$/;
      // check for proper email
      if (step === 10 && formData.email === "") {
        // If the email input is empty, we need to show an error message
        document.querySelector(".errorTextAnswer").style.display = "block";
        document.querySelector(".errorEmailText").style.display = "none";
      } else if (
        step === 10 &&
        emailCheckRegex.test(formData.email) === false &&
        formData.email !== ""
      ) {
        // If the email is not valid, we need to show an error message
        document.querySelector(".errorEmailText").style.display = "block";
        document.querySelector(".errorTextAnswer").style.display = "none";
      }

      if (step === 10 && oldPhoneNumber === "") {
        // If the phone number input is empty, we need to show an error message
        document.querySelector(".errorTextAnswer").style.display = "block";
        document.querySelector(".errorPhoneText").style.display = "none";
      } else if (
        step === 10 &&
        phoneCheckRegex.test(oldPhoneNumber) === false &&
        oldPhoneNumber !== ""
      ) {
        // If the phone number is not valid, we need to show an error message
        document.querySelector(".errorPhoneText").style.display = "block";
        document.querySelector(".errorTextAnswer").style.display = "none";
      } else if (
        step === 10 &&
        phoneCheckRegex.test(oldPhoneNumber) === true &&
        oldPhoneNumber !== ""
      ) {
        // If the phone number is valid hide the error message
        document.querySelector(".errorPhoneText").style.display = "none";
      }

      // Default error message asking to answer the quesiton
      // This is the parent of .errorText
      if (document.querySelector(".errorTextContainer")) {
        document.querySelector(".errorTextContainer").style.display = "block";
      }
      // Default error message asking to answer the quesiton
      if (document.querySelector(".errorText")) {
        document.querySelector(".errorText").style.display = "block";
      }
      // Check if the step has the ID "button1", "button2", "button3", "button4", "button5"
      // If the step is not valid, we need to highlight the buttons depending on what ID the steps have
      if (
        document.querySelector("#button1") &&
        !document.querySelector("#button2")
      ) {
        document.querySelector("#button1").style.border = "1px red solid";
      } else if (
        document.querySelector("#button1") &&
        document.querySelector("#button2") &&
        !document.querySelector("#button3")
      ) {
        document.querySelector("#button1").style.border = "1px red solid";
        document.querySelector("#button2").style.border = "1px red solid";
      } else if (
        document.querySelector("#button2") &&
        document.querySelector("#button3") &&
        !document.querySelector("#button4")
      ) {
        document.querySelector("#button1").style.border = "1px red solid";
        document.querySelector("#button2").style.border = "1px red solid";
        document.querySelector("#button3").style.border = "1px red solid";
        // document.querySelector("#button4").style.border = "1px red solid";
        // document.querySelector("#button5").style.border = "1px red solid";
      } else if (
        document.querySelector("#button2") &&
        document.querySelector("#button3") &&
        document.querySelector("#button4") &&
        !document.querySelector("#button5")
      ) {
        document.querySelector("#button1").style.border = "1px red solid";
        document.querySelector("#button2").style.border = "1px red solid";
        document.querySelector("#button3").style.border = "1px red solid";
        document.querySelector("#button4").style.border = "1px red solid";
      } else if (
        document.querySelector("#button5") &&
        !document.querySelector("#button6")
      ) {
        document.querySelector("#button1").style.border = "1px red solid";
        document.querySelector("#button2").style.border = "1px red solid";
        document.querySelector("#button3").style.border = "1px red solid";
        document.querySelector("#button4").style.border = "1px red solid";
        document.querySelector("#button5").style.border = "1px red solid";
      } else if (document.querySelector("#button7")) {
        document.querySelector("#button1").style.border = "1px red solid";
        document.querySelector("#button2").style.border = "1px red solid";
        document.querySelector("#button3").style.border = "1px red solid";
        document.querySelector("#button4").style.border = "1px red solid";
        document.querySelector("#button5").style.border = "1px red solid";
        document.querySelector("#button6").style.border = "1px red solid";
        document.querySelector("#button7").style.border = "1px red solid";
      }
      updateErrorsFormSteps({
        formData,
        step,
        setValidationError,
      });
      return false;
    }

    if (isValid && step !== 10) {
      googleSheetUpdateMobile(payload);
    }
    // If its the last step and everything is valid call the function to submit the form
    if (step === 10 && isValid) {
      googleSheetUpdateMobile(payload);
      handleSubmit();
    }
    return true;
  };

  // Send payload to Zapier and redirect user
  const sendToZapier = async (payload) => {
    // const devURL = process.env.REACT_APP_CLOUD_WEBHOOK;
    const zapierURL = process.env.REACT_APP_ZAPIER_URL;
    try {
      await fetch(zapierURL, {
        method: "POST",
        body: JSON.stringify(payload),
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Failed to send to Zapier");
          }
          console.log("Successfully sent to Zapier!");
          console.log(res);
        })
        .catch((err) => {
          console.error("Zapier post error", err);
        });
      return;
    } catch (e) {
      console.log(e);
    } finally {
      // Redirect user to the next page based on response from form
      if (
        formData.attorneyHelping === "Yes" ||
        formData.outOfWork === "No" ||
        formData.workedFiveYearsSince === "No" ||
        formData.receivingSSDIBenefits === "Yes"
      ) {
        // Redirect to not qualified page
        window.location.href =
          "https://www.citizensdisability.com/seclp-lp-ty-universal/";
      } else {
        // Redirect to qualified page
        window.location.href =
          "https://www.citizensdisability.com/sec-thank-you-dti-copy/";
      }
      clearStorage();
      // sessionStorage.removeItem("unique_id");
      // // Clear session storage
      // sessionStorage.removeItem("formData");
      // sessionStorage.removeItem("currentStep");
      // sessionStorage.removeItem("selectedOption1");
      // sessionStorage.removeItem("selectedOption2");
      // sessionStorage.removeItem("selectedOption3");
      // sessionStorage.removeItem("selectedOption4");
      // sessionStorage.removeItem("selectedOption6");
      // sessionStorage.removeItem("selectedOption7");
      // sessionStorage.removeItem("selectedOption9");
      // // reset form data
      // setFormData({
      //   firstName: "",
      //   lastName: "",
      //   phoneNumber: "",
      //   email: "",
      //   receivingSSDIBenefits: "",
      //   outOfWork: "",
      //   lastYearWorked: "",
      //   workedFiveYearsSince: "",
      //   receivingTreatment: "",
      //   ageRange: "",
      //   zipCode: "",
      //   attorneyHelping: "",
      //   trustedForm: "",
      //   utm_source: "",
      //   utm_medium: "",
      //   utm_campaign: "",
      //   utm_content: "",
      //   cc: "",
      //   utm_id: "",
      //   utm_term: "",
      //   fbclid: "",
      //   referringURL: "",
      //   userAgent: "",
      //   createdAt: "",
      // });
    }
  };

  // Form Submit / Brings IP Adress and calls zapier function / Also gets the Date
  const handleSubmit = async () => {
    await sendToZapier(payload);
    return;
  };
  // Call back for function
  // useBeforeUnload(payload, formData);

  // Form steps
  const steps = [
    <FirstStep
      formData={formData}
      validationError={validationError}
      handleFieldChange={handleFieldChange}
    />,
    <SecondStep
      formData={formData}
      validationError={validationError}
      handleFieldChange={handleFieldChange}
    />,
    <ThirdStep
      formData={formData}
      validationError={validationError}
      handleFieldChange={handleFieldChange}
    />,
    <FourthStep
      formData={formData}
      validationError={validationError}
      handleFieldChange={handleFieldChange}
    />,
    <FifthStep
      formData={formData}
      validationError={validationError}
      handleFieldChange={handleFieldChange}
    />,
    <SixthStep
      formData={formData}
      validationError={validationError}
      handleFieldChange={handleFieldChange}
    />,
    <SeventhStep
      formData={formData}
      validationError={validationError}
      handleFieldChange={handleFieldChange}
    />,
    <EighthStep
      formData={formData}
      validationError={validationError}
      handleFieldChange={handleFieldChange}
    />,
    <NinthStep
      formData={formData}
      validationError={validationError}
      handleFieldChange={handleFieldChange}
    />,
    <TenthStep
      formData={formData}
      validationError={validationError}
      handleFieldChange={handleFieldChange}
    />,
  ];

  useEffect(() => {
    // Set unique ID
    sessionStorage.setItem("unique_id", uniqueIdRef.current);
    const didRefresh = () => {
      setFormData((prev) => ({
        ...prev,
        refresh: refreshed,
      }));
      sessionStorage.removeItem("row_created");
      clearStorage();
    };

    window.addEventListener("load", didRefresh);
    // Get User IP Address
    const fetchIpAddress = async () => {
      try {
        const response = await fetch("https://geolocation-db.com/json/");
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setUserIPAdress(data.IPv4); // Update state with IP
      } catch (e) {
        console.log("IP fetch error:", e);
      }
    };
    fetchIpAddress();

    // Call utm parameter function
    const utmParams = getUTMParams();
    // Update state with utm parameters from the function
    setFormData((prevData) => ({ ...prevData, ...utmParams }));

    // Trusted form cert function
    const getTrustedFormCertValue = () => {
      const inputField = document.getElementById("xxTrustedFormCertUrl_0");
      // const inputFieldBackup = document.getElementById("xxTrustedFormCertUrlAdded_0");
      return inputField ? inputField.value : "";
    };

    // Wait for TrustedForm to inject the value
    const interval = setInterval(() => {
      const certValue = getTrustedFormCertValue();
      if (certValue) {
        // Update state and form data
        setTrustedFormCert(certValue); // Update trusted form state with cert
        setFormData((prevData) => ({ ...prevData, trustedForm: certValue })); // Update form data state with cert
        clearInterval(interval); // Stop checking once value is set
        // console.log("Trusted Form Cert Value: ", certValue);
      }
    }, 500); // Check every 500ms
    return () => clearInterval(interval); // Cleanup interval when component unmounts
  }, [trustedFormCert, refreshed]);
  return (
    <>
      <div className="minHeightContainer" style={{ width: "100%" }}>
        <StepController
          className="stepControllerMobile"
          formTitle="Atticus Flow Form"
          manageNextStepValidation={manageNextStepValidation}
          steps={steps}
          stepsAmount={10}
        />
        <form style={{ width: "100%" }}>
          <input
            type="hidden"
            name="xxTrustedFormCertUrlAdded"
            id="xxTrustedFormCertUrlAdded_0"
            value={trustedFormCert}
          />
        </form>
      </div>
    </>
  );
};

export default Form;
